import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: now-wrap;
  gap: 4px;
`;

export const Item = styled.div<{ isFull?: boolean }>`
  height: 8px;
  border-radius: 2px;
  flex: 1;

  background-color: ${(props) => props.theme.color.light.shade};

  ${(props) => props.isFull && `background-color: ${props.theme.color.blue.default}`};
`;
